import AXIOS from './util'

const state = {
  list: []
}

const mutations = {
  LIST (state, value) {
    state.list = value
  },
  SET (state, value) {
    state.list.forEach(item => {
      if (item.id === value.id) {
        const i = state.list.indexOf(item)
        state.list[i] = value
      }
    })
  }
}

const actions = {
  INIT ({ state, commit, dispatch }) {
    dispatch('LOAD')
  },
  SET_LIST ({ state, commit }, value) {
    commit('LIST', value)
  },
  LOAD ({ state, commit, dispatch }) {
    AXIOS.get('/invoices')
      .then((response) => {
        dispatch('SET_LIST', response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  NEW ({ state, commit, dispatch }, value) {
    AXIOS.post('/invoices', [value])
      .then((response) => {
        dispatch('LOAD')
      })
      .catch((error) => {
        console.log(error)
      })
  },
  SAVE ({ state, commit, dispatch }, value) {
    AXIOS.put('/invoice', value)
      .then((response) => {
        dispatch('LOAD')
      })
      .catch((error) => {
        console.log(error)
      })
  },
  DELETE ({ state, commit, dispatch }, id) {
    AXIOS.delete(`/invoice/${id}`)
      .then((response) => {
        dispatch('LOAD')
      })
      .catch((error) => {
        console.log(error)
      })
  },
  PRINT ({ state, commit, dispatch }, id) {
    AXIOS.get(`/invoice/${id}`)
      .then((response) => {
        const win = window.open('', '_blank')
        win.document.write(response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
